import React from 'react';
import { useSearchBar } from '../hooks/useSearchBar';

type SearchBarInnerContainerProps = { children: React.ReactNode };

const SearchBarInnerContainer = ({ children }: SearchBarInnerContainerProps) => {
	const { blockClass } = useSearchBar();

	return (
		<div
			className={`searchBarInnerContainer searchBarInnerContainer--${blockClass} relative-m w-100 vtex-store-components-3-x-searchBarInnerContainer ${blockClass ? 'vtex-store-components-3-x-searchBarInnerContainer--' + blockClass : ''}`}
		>
			{children}
			<div></div>
			<div style={{ width: 'auto', height: '1px', marginTop: '-1px' }}></div>
		</div>
	);
};

export default SearchBarInnerContainer;
